import type { ObservabilityProvider } from '../types';
import { noopScopedContext } from '../scoped-context';

export const noopProvider: ObservabilityProvider = {
  context: noopScopedContext,
  metrics: {
    emit: () => {},
    increment: () => {},
    histogram: () => {},
  },
  logs: {
    log: () => {},
  },
  traces: {
    span: async (_name, _attrs, fn) => fn({ setAttributes: () => {} }),
  },
  analytics: {
    track: () => {},
    setUser: () => {},
    clearUser: () => {},
  },
};
